<template>
	<div>
		<div class="common_box_tit">
			<div>pdf文件</div>
			<div class="bom_line"></div>
		</div>
		<div class="pdf">
			<!-- <img src="../../assets/images/4.png"/> -->
			<div class="list_box">
				<div class="single" v-for="(it,i) in pptList" :key="i" @click="lookPdf(it)">{{it.name}}</div>
			</div>
			<!-- <div class="common_more" style="float: right;margin-top: 10px;">
				<span>更多</span>
				<span class="iconfont icon-gengduo"></span>
			</div> -->
		</div>
	</div>
</template>

<script>
	import {
		getResourcese
	} from '@/api/home/guild'
	export default {
		components: {

		},
		data() {
			return {
				pptList: [],
			}

		},
		mounted() {
			this.getResourcesePPT();
		},
		methods: {
			getResourcesePPT() {
				getResourcese({
					type: 7,
				}).then(res => {
					if (res.code == 200 || res.code == 0) {
						this.pptList = res.result;
					}
				})
			},
			lookPdf(it){
				window.open(it.resource)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.pdf {
		margin: 20px 0 30px;
		img {
			width: 100%;
			height: 180px;
		}
		
		.tit {
			color: #3E41F0;
			font-family: Source Han Sans CN;
			font-size: 20px;
			white-space: nowrap;
			margin-bottom: 20px;
		}
		
		.list_box {
			div {
				border-bottom: 1px solid #eee;
				padding-bottom: 10px;
				margin-top: 10px;
				font-size: 14px;
				cursor: pointer;
				padding: 10px 0;
			}
			>div:hover{
				background-color: #eee;
			}
		}
	}
</style>
